import * as Tool from '../tool/index';

function getTitle (vm) {
  const { title } = vm.$options;
  if (title) {
    return typeof title === 'function'
      ? title.call(vm)
      : title;
  }
}

const serverTitleMixin = {
  created () {
    const title = getTitle(this);
    if (title) {
      this.$ssrContext.title = `${title}`;
    }
  }
};

const clientTitleMixin = {
  mounted () {
    const title = getTitle(this);
    if (title) {
      document.title = `${title}`;
      const mobile = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(mobile)) {
        var iframe = document.createElement('iframe');
        iframe.style.visibility = 'hidden';
        // 替换成站标favicon路径或者任意存在的较小的图片即可
        iframe.setAttribute('src', '//x.autoimg.cn/cfw/yc/images/favicon.ico');
        const iframeCallback = function () {
          setTimeout(function () {
            iframe.removeEventListener('load', iframeCallback);
            document.body.removeChild(iframe);
          }, 0);
        };
        iframe.addEventListener('load', iframeCallback);
        document.body.appendChild(iframe);
        // 动态设置标题
        if (Tool.webApp.checkAutoHomeApp()) {
          require('../app/jsBridge');  // eslint-disable-next-line
          window.jsBridge.setActionBarInfo({
            title: title,
            addmenulist: [],
            stablemenulist: [],
            success: (res) => {
              console.log(JSON.stringify(res));
            },
            fail: (res) => {
              console.log(JSON.stringify(res));
            }
          });
        }
      }
    }
  }
};

export default process.env.VUE_ENV === 'server'
  ? serverTitleMixin
  : clientTitleMixin;
